import isFeatureEnabled from './isFeatureEnabled'
import { BANKRATE_IFRAME, ZABLE } from './const'

const IS_ZABLE_ENABLED = isFeatureEnabled(ZABLE)
const IS_BANKRATE_IFRAME_ENABLED = isFeatureEnabled(BANKRATE_IFRAME)

export { IS_ZABLE_ENABLED, IS_BANKRATE_IFRAME_ENABLED }
